// src/data/industryPlanNotes.js

export const INDUSTRY_PLAN_NOTES = {
  Basic: {
    default: "Great starter for teams under 10.",
    Technology: "Good fit for early-stage engineering teams.",
    Healthcare: "Simple rota and time for small practices.",
    Finance: "Good for small back-office teams.",
    Security: "Great for scheduling guards and tracking basic hours.",
    Retail: "Covers shift needs for small locations.",
    Hospitality: "Rotating shifts for seasonal staff.",
    Restaurant: "FOH/BOH scheduling and time basics.",
    Salon: "Manage stylists and chair time.",
    Fitness: "Class and trainer scheduling basics.",
    Automotive: "Shifts for service bays and front desk.",
    Cleaning: "Crew rosters and basic time logs.",
    Construction: "Crew time across job sites.",
    Manufacturing: "Starter for small lines and shifts.",
    Transportation: "Dispatcher and driver hours, simple.",
    RealEstate: "Track hours for office assistants.",
    Education: "Admin and support staff coverage.",
    Government: "Good for small departments.",
    Nonprofit: "Volunteer and staff time tracking.",
    Other: "Solid starter set for small teams.",
  },

  Standard: {
    default: "Most popular for 6–25 employees.",
    Technology: "Popular with growing dev and support teams.",
    Healthcare: "Works well for clinics and practices.",
    Finance: "Adds PTO and expenses for audits.",
    Security:
      "Adds leave + expenses for uniforms, mileage, and reimbursements.",
    Retail: "Leave requests and petty cash handling.",
    Hospitality: "PTO across rotating teams, reimbursements.",
    Restaurant: "Time off and reimbursements for crews.",
    Salon: "Time off and supply expenses.",
    Fitness: "Trainer PTO and program expenses.",
    Automotive: "Shop expenses and technician PTO.",
    Cleaning: "Mileage and PTO per crew.",
    Construction: "Per-diem and crew leave tracking.",
    Manufacturing: "Shift PTO and expense control.",
    Transportation: "Driver allowances and time off.",
    RealEstate: "Mileage and client expense tracking.",
    Education: "Faculty leave and reimbursements.",
    Government: "Policy-aligned leave and expenses.",
    Nonprofit: "Grant-coded expenses and leave.",
    Other: "Adds leave and expenses as you grow.",
  },

  Premium: {
    default: "Best for compliance and analytics-driven orgs.",
    Healthcare: "Preferred where audits and training matter.",
    Technology: "All-in for larger eng and IT operations.",
    Finance: "Compliance reporting and training.",
    Security:
      "Best for training compliance, incident workflows, and reporting.",
    Retail: "Training and analytics for multi-site.",
    Hospitality: "Seasonal onboarding and analytics.",
    Restaurant: "Training modules and ops analytics.",
    Salon: "Upskill staff and track policies.",
    Fitness: "Certifications and program analytics.",
    Automotive: "SOP training and IT ticketing.",
    Cleaning: "Safety training and incident tracking.",
    Construction: "Safety training plus site ticketing.",
    Manufacturing: "SOP training, analytics, IT helpdesk.",
    Transportation: "Regulatory refreshers and ticketing.",
    RealEstate: "Onboarding and IT requests in one place.",
    Education: "LMS-lite training and campus helpdesk.",
    Government: "Audit trails, training, and helpdesk.",
    Nonprofit: "Board training, analytics, and IT support.",
    Other: "Full suite with training, analytics, helpdesk.",
  },

  Training: {
    default: "Ideal if you only need training and tracking.",
    Healthcare: "Assign policy refreshers and certifications.",
    Technology: "Onboard engineers with videos and docs.",
    Finance: "Compliance courses and attestations.",
    Security: "Assign SOPs, post orders, certifications, and refreshers.",
    Retail: "Store onboarding and product refreshers.",
    Hospitality: "Service standards and seasonal onboarding.",
    Restaurant: "Food safety and new-hire training.",
    Salon: "Brand standards and service refreshers.",
    Fitness: "Coach certifications and program modules.",
    Automotive: "Shop safety and procedure training.",
    Cleaning: "Safety, chemicals, and site procedures.",
    Construction: "Site safety and toolbox talks.",
    Manufacturing: "SOPs and equipment training.",
    Transportation: "Driver orientation and renewals.",
    RealEstate: "Policies and sales playbooks.",
    Education: "Staff onboarding and compliance topics.",
    Government: "Policy courses and compliance.",
    Nonprofit: "Volunteer onboarding and safeguarding.",
    Other: "Straightforward course assignments and tracking.",
  },

  Helpdesk: {
    default: "Great if you only need IT ticketing and SLAs.",
    Technology: "Centralize bug and IT intake and triage.",
    Healthcare: "Support devices and EHR access issues.",
    Finance: "Access, audits, and workstation tickets.",
    Security:
      "Track device/POS access issues and field equipment tickets fast.",
    Retail: "Store IT tickets and back-office requests.",
    Hospitality: "Front-desk and POS support tickets.",
    Restaurant: "Kitchen equipment and POS issues.",
    Salon: "POS and device support in one place.",
    Fitness: "Member device and facility tickets.",
    Automotive: "Diagnostics tools and kiosk tickets.",
    Cleaning: "Field device and incident tickets.",
    Construction: "Site device and tool issues.",
    Manufacturing: "Line systems and workstation tickets.",
    Transportation: "Driver devices and dispatch systems.",
    RealEstate: "Laptop, CRM, and office tickets.",
    Education: "Staff devices, classrooms, labs.",
    Government: "Policy-tracked requests and SLAs.",
    Nonprofit: "Simple intake with grant tags.",
    Other: "Fast intake, triage, and resolution tracking.",
  },
};
